<app-header-container>
  <div header-content>
    <div class="d-flex justify-content-between align-items-center">
      <div class="text-container">
        <div *ngIf="title !== ''" class="header-text">
          {{ title }}
        </div>
      </div>
      <div class="button-container">
        <app-primary-button
          i18n
          *ngIf="environment.environmentName === 'dev'"
          (buttonClicked)="testCreditCardClicked.emit()"
          >Test Credit Card</app-primary-button
        >
        <app-search-input />
        <app-tertiary-button
          (buttonClicked)="rearrangeButtonClicked.emit()"
          [size]="BaseButtonSizeEnum.sm"
          leftIconSrc="assets/icons/dark/List.svg"
          i18n>
          Rearrange
        </app-tertiary-button>
      </div>
    </div>
  </div>
</app-header-container>
